import useMediaQuery from 'hooks/useMediaQuery';
import FeautersItem from './FeaturesItem';
import { useState } from 'react';
import HideButton from 'components/common/Buttons/HideButton';

const FeautersItems = ({ features }) => {
    const isMobile = useMediaQuery('max-width: 640px');
    const [active, setActive] = useState(false);

    function toggleAccordion() {
        setActive(!active);
    }
    return isMobile ? (
        <>
            <div className='features-items'>
                {features?.slice(0, 3).map((item, index) => (
                    <FeautersItem key={index} item={item.attributes} id={item.id} />
                ))}
            </div>

            <div className={`features-items-mob-container ${active ? "open" : ""}`}>
                <div className='features-items'>
                    {features?.slice(3).map((item, index) => (
                        <FeautersItem key={index} item={item.attributes} id={item.id} />
                    ))}
                </div>

            </div>
            <HideButton text={"Show more"} onClick={toggleAccordion} isOpen={active} />
        </>
    ) :
        (
            <div className='features-items'>
                {features?.map((item, index) => (
                    <FeautersItem key={index} item={item.attributes} id={item.id} />
                ))}
            </div>

        );
}

export default FeautersItems;